// @ts-nocheck
import getColor from "@insite/mobius/utilities/getColor";
import breakpointValues, { BreakpointValue } from "@toolkit/Framework/Common/Utilities/breakpointValues";
import { pxToRem, pxToRemArray } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { css } from "styled-components";

/* Store Custom Code - Start */
import breakpoint from "@toolkit/Framework/Common/Utilities/breakpoint";
/* Store Custom Code - End */

export const boxStyles = (
    padding: BreakpointValue[] | null = pxToRemArray([25, 32, 40]),
    // Store Custom Code
    newDesign?: boolean,
) => css`
    /* Store Custom Code - Start */
    ${newDesign
        ? css`
              background-color: ${getColor("common.accent")};
              border-radius: ${pxToRem(8)};
          `
        : css`
              border-radius: ${pxToRem(4)};
              box-shadow: ${x => x.theme.shadows["2"]};
              background-color: ${getColor("common.background")};
          `}
    /* Store Custom Code - End */
    ${padding ? breakpointValues(padding, "padding") : null}
`;

export const boxStickyStyles = () => css`
    padding: ${pxToRem(10)};
    box-shadow: ${props => props.theme.shadows.e60Up};
    background-color: ${getColor("common.background")};
`;

/* Store Custom Code - Start */
export const boxLayoutStickyStyles = () => css`
    ${boxStickyStyles()}
    ${x => breakpointValues(x.theme.design.layout.spacing.side, ["padding-right", "padding-left"])}
`;

export const boxSignInStyles = () => css`
    ${breakpoint("md")} {
        ${boxStyles(null)};
        padding: ${pxToRem(20)};
        height: 100%;
    }

    ${breakpoint("lg")} {
        padding: ${pxToRem(32)};
    }

    ${breakpoint("xl")} {
        padding: ${pxToRem(48)};
    }
`;

/**
 * Glass card over a page gradient. The translucent whites have no token: the palette holds solid
 * colours only, and these read as glass over the gradient rather than as a surface colour.
 */
export const boxGlassStyles = () => css`
    border: ${pxToRem(1)} solid rgba(255, 255, 255, 0.25);
    border-radius: ${pxToRem(24)};
    background-color: rgba(255, 255, 255, 0.15);
    color: ${getColor("common.background")};
`;
/* Store Custom Code - End */
